<form autocomplete="off" class="p-0" novalidate [formGroup]="reportForm">
  <div class="main-content side-content pt-0 ml-0 mdu-wrapper">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body pb-0">
                <div class="col-md-12 prpl">

                  <div class="row align-items-center">
                    <div class="col-md-4 prpl">
                      <div class="d-flex align-items-center">
                        <img alt="Logo" src="../../assets/img/attendance.png"
                             class="mh-45px pb-2">
                        <p class="mb-1">
                          <span class="main-content-label"><b>Exams Eval Marks Report</b></span><br>
                          <span class="text-muted card-sub-title mb-0">
                            Download Evaluation &amp; Zero Marks Reports
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-2">

                  <!-- Dropdowns -->
                  <div class="row clearfix mt-2">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Session</mat-label>
                          <mat-select #selSession placeholder="Session"
                                      class="colorblack" formControlName="SessionId">
                            <mat-select-filter *ngIf="selSession.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'SnName'"
                                               [array]="sessionList"
                                               (filteredReturn)="SessionFilterList = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList"
                                        [value]="item.SnNo"
                                        (click)="getCourse(item)">
                              {{ item.SnName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="reportForm.get('SessionId').hasError('required')">
                            Session is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course</mat-label>
                          <mat-select #selCourse class="colorblack" formControlName="course">
                            <mat-select-filter *ngIf="selCourse.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'CoName'"
                                               [array]="CourseList"
                                               (filteredReturn)="filteredListCourse = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListCourse"
                                        [value]="item.CoCode"
                                        (click)="getExamList(item)">
                              {{ item.CoCode }} - {{ item.CoName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="reportForm.get('course').hasError('required')">
                            Course is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select #selExam placeholder="Exam" formControlName="EmId">
                            <mat-select-filter *ngIf="selExam.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'EmName'"
                                               [array]="examList"
                                               (filteredReturn)="filteredListExam = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListExam" [value]="item.EmId">
                              {{ item.EmCoCode }}-{{ item.EmName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="reportForm.get('EmId').hasError('required')">
                            Exam is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- Buttons -->
                  <div class="row mt-2 mdu-actions-row">
                    <div class="col-md-12 d-flex justify-content-end align-items-center flex-wrap">

                      <button type="button"
                              class="btn btn-primary mdu-action-btn mr-2"
                              [disabled]="isDownloadingEvaluation || isDownloadingZero || !isReportReady()"
                              (click)="downloadEvaluationReport()">
                        <span class="d-inline-flex align-items-center">
                          <i class="fa fa-file-text-o mr-2"></i>
                          <span *ngIf="!isDownloadingEvaluation">Evaluation Report</span>
                          <span *ngIf="isDownloadingEvaluation">
                            <i class="fa fa-spinner fa-spin mr-1"></i>Downloading...
                          </span>
                        </span>
                      </button>

                      <!-- <button type="button"
                              class="btn btn-primary mdu-action-btn"
                              [disabled]="isDownloadingEvaluation || isDownloadingZero || !isReportReady()"
                              (click)="downloadZeroMarksReport()">
                        <span class="d-inline-flex align-items-center">
                          <i class="fa fa-file-text-o mr-2"></i>
                          <span *ngIf="!isDownloadingZero">Zero Marks Report</span>
                          <span *ngIf="isDownloadingZero">
                            <i class="fa fa-spinner fa-spin mr-1"></i>Downloading...
                          </span>
                        </span>
                      </button> -->

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>